export const DX_LICENSE_KEY =
  "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjhmMmVhY2UzLWEyYjAtNGNlZS1hMjY4LTFiYTY4MmU2MGJhZSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.YWTITTPtzoht0Ms7xWjmF1JyxJpKJjKYpMeAEvlJKp71hfp2YlZSP0wna4PZZvy24HGxEy9P91gsM1B36WKhzGQV+k1DoA7XgJ+WyEbWqeBJxLpPEuMqy0r6oDc/MVmI8PHOZw==";
